import React, { useCallback } from 'react';
import { useChangeActiveMutation, useGetUserQuery } from '@/redux';
import { Button } from 'antd';
import { useSubmitUserDetailsFormik } from './UserDetailsPanel';
import { useTranslation } from 'react-i18next';
import { notify } from '@/components';
import classes from './UserDetailsActionButtons.module.scss';

interface Props {
  id: string;
}

const useToggleActive = ({ id }: Props) => {
  const { data } = useGetUserQuery({ id });
  const { isActive } = data ?? {};
  const [changeActive] = useChangeActiveMutation();

  return useCallback(
    () =>
      changeActive({ id, value: !isActive })
        .unwrap()
        .then(() => notify.success.t(isActive ? 'users.deactivated' : 'users.activated')),
    [id, isActive, changeActive],
  );
};

export function UserDetailsActionButtons(props: Props) {
  const { id } = props;
  const { t } = useTranslation();
  const submit = useSubmitUserDetailsFormik();
  const { data } = useGetUserQuery({ id });
  const { isActive } = data ?? {};
  const toggleActive = useToggleActive(props);

  if (!data) {
    return null;
  }

  return (
    <div className={classes.userDetailsActionButtons}>
      <Button size="large" type="primary" danger={isActive} onClick={toggleActive}>
        {t('users.details.' + (isActive ? 'deactivate' : 'activate'))}
      </Button>
      <Button size="large" disabled={!isActive} type="primary" onClick={submit}>
        {t('users.details.save')}
      </Button>
    </div>
  );
}
